import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Classroom360Service } from '../../../classroom360/classroom360.service';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { SharedService } from '../../../shared-components/shared.service';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { StudentService } from '../../../shared-components/student/student.service';
import { UserService } from '../../../shared-components/user/user.service';
import { SendEmailService } from '../../../shared-modules/send-email/send-email.service';
import { Student360Service } from '../../student360.service';

@Component({
    selector: 'by-schedule-table',
    templateUrl: './by-schedule-table.component.html',
    animations: [detailExpand],
})
export class ByScheduleTableComponent implements OnInit, AfterViewInit, OnDestroy {

    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    columnsToDisplayCourse: string[] = ['More', 'Meets', 'Dropped', 'Term', 'CourseSection', 'Course', 'TeacherName', 'Absences', 'Tardies'];
    @Input() courseSchedules: CourseSchedule[];
    @Input() calendarUseAttendanceTypes: boolean;
    clearFilterEvent = new EventEmitter<any>();
    @Input() V10: boolean;
    subscriptions: Subscription[] = [];
    canSendEmail = true;

    constructor(
        private student360Service: Student360Service,
        private classroom360Service: Classroom360Service,
        private sharedService: SharedService,
        private sendEmailService: SendEmailService,
        private studentService: StudentService,
        private userService: UserService,
        private router: Router) {
    }

    ngOnInit() {
        this.angularMatData.data = this.courseSchedules;
        if (!this.V10) {
            this.columnsToDisplayCourse = ['More', 'Meets', 'Term', 'CourseSection', 'Course', 'TeacherName', 'Absences', 'Tardies'];
        }

        this.angularMatData.sort = this.sort;

        if (this.userService.userType == 1) {
            this.subscriptions.push(this.classroom360Service.observableStaffAssignedPortalsStream$.subscribe(portals => {
                if (portals.filter(o => o.PortalName == 'Send Email' && o.Disabled == false && o.Deleted == false).length == 0) {
                    this.canSendEmail = false;
                }
            }));
        }
        else {
            this.subscriptions.push(this.student360Service.observableParentAssignedPortalsStream$.subscribe(portals => {
                if (portals.filter(o => o.PortalName == 'Send Email' && o.Disabled == false && o.Deleted == false).length == 0) {
                    this.canSendEmail = false;
                }
            }));
        }
    }

    ngAfterViewInit() {
        if (this.studentService.selectedCourse && this.studentService.selectedCourse.SubjectCode != undefined) {
            const course = this.courseSchedules.filter(o => o.SubjectCode == this.studentService.selectedCourse.SubjectCode)[0];
            this.angularMatData.toggleExpanded(course);
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    sendEmail(teacherName: string, teacherEmail: string) {
        this.sendEmailService.teacherName = teacherName;
        this.sendEmailService.teacherEmailAddress = teacherEmail;
        if (!this.userService.studentInformationView) {
            this.router.navigateByUrl('/student360/sendEmail');
        }
        else {
            this.userService.updateStudentViewRoute('/student360/sendEmail');
        }
    }

    // ----------Angular Material------------------------------------
    toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.sharedService.updateShowSpinner(true);
        setTimeout(() => {
            this.angularMatData.expandAll(expand);
            this.sharedService.updateShowSpinner(false);
        }, 100);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);

    }

    getAriaRowByCourse(row: CourseSchedule): string {
        const colList: string[] = ['Meets',
            'Dropped',
            'Term',
            'Course-Section',
            'Course Name',
            'Teacher',
            'Absences',
            'Tardies'];

        const dataList: string[] = [row.Meets,
        row.Dropped,
        row.Term,
        row.CourseSection,
        row.Course,
        row.TeacherName,
        row.Absences.toString(),
        row.Tardies.toString()];

        return AriaDirective.concatAriaStrings(colList, dataList) + (row.AttendanceDetails.length > 0 ? ' Expand for more details' : ' No additional details');
    }
}